export default "__VITE_ASSET__0yYPKbDQ__"